import { render, staticRenderFns } from "./ReportStudentIslam.vue?vue&type=template&id=4b60cd89"
import script from "./ReportStudentIslam.vue?vue&type=script&lang=js"
export * from "./ReportStudentIslam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports